import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import { ApiProvider } from './services/api/provider';

const msalInstance = new PublicClientApplication(msalConfig);

async function bootstrap() {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  try {
    console.log('🔎 Initializing MSAL...');
    await msalInstance.initialize();

    console.log('🔄 Handling redirect promise...');
    await msalInstance.handleRedirectPromise().catch(err => {
      console.error('❌ Redirect handling error:', err);
    });
    console.log('✅ Redirect handled');

    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <ApiProvider baseURL={process.env.REACT_APP_API_BASE || '/api'}>
            <App />
          </ApiProvider>
        </MsalProvider>
      </React.StrictMode>
    );
  } catch (err) {
    console.error('❌ MSAL bootstrap failed:', err);
    root.render(
      <div style={styles.containerStyle}>
        <p style={styles.errorTextStyle}>
          Failed to initialize authentication. Please try again or contact
          support.
        </p>
      </div>
    );
  }
}

const styles: Record<string, React.CSSProperties> = {
  containerStyle: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  errorTextStyle: {
    color: '#dc2626', // text-red-600
  },
};

bootstrap();
